import { HTMLLink } from '@sitecore-jss/sitecore-jss-nextjs';
import Head from 'next/head';

import { RouteFields } from './Layout';

type MetaTagsProps = {
  fields: RouteFields;
  headLinks: HTMLLink[];
  publicUrl: string;
};

export const MetaTags = ({ fields, headLinks, publicUrl }: MetaTagsProps) => {
  let robotParts = [];
  if (fields.NoIndex?.value) {
    robotParts.push('noindex');
  }
  if (fields.NoFollow?.value) {
    robotParts.push('nofollow');
  }
  const robotText = robotParts.join(',');

  return (
    <Head>
      <title>{(fields.PageTitle || fields.Title)?.value?.toString() || 'Page'}</title>
      <link rel="icon" href={`${publicUrl}/favicon.ico`} />
      {headLinks.map((headLink) => (
        <link rel={headLink.rel} key={headLink.href} href={headLink.href} />
      ))}
      {!!robotText.length && <meta name="robots" content={robotText} />}
    </Head>
  );
};
